import { KYMW2400Model } from '../kymw2400.model';
import { PageTemplateIDModel } from '../vo/page-template-id.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページテンプレート削除コマンド。
 * 指定されたテンプレート情報を削除する。
 *
 * @export DeleteTemplateService
 * @class DeleteTemplateService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeleteTemplateService extends PlessJsonResponderSub<any> {

  private model: KYMW2400Model = null;
  private vo: PageTemplateIDModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteTemplateService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PageTemplateID: this.vo.pageTemplateID
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2400Model} model モデルクラス
   * @memberof DeleteTemplateService
   */
  execute(model: KYMW2400Model) {
    this.model = model;
    this.vo = this.model.createPageTemplateIDVO();
    this.send('deleteTemplate', this.getBody());
    this.model.clearTemplateList();
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteTemplateService
   */
  success(data: any) {
    this.model.updatePageTemplateList(data);
  }
}
